"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants = __importStar(require("./constants"));
const SearchQueryBuilder_1 = __importDefault(require("./SearchQueryBuilder"));
const SearchJSONBuilder_1 = __importDefault(require("./SearchJSONBuilder"));
class QueryController {
    constructor(props) {
        this.props = props;
        this.searchProps = {
            config: props.config,
            states: props.states,
        };
        this.streamed = props.config[constants.GuiStreamed] || props.streamed || constants.SEARCH_DEFAULT_STREAMED;
        this.method = props.config[constants.GuiMethod] || constants.SEARCH_DEFAULT_METHOD;
    }
    // --------------------------------- public methods ------------------------------------------------------------------
    getUrl() {
        if (this.method === 'GET') {
            return new SearchQueryBuilder_1.default(this.searchProps).getUrl();
        }
        else {
            return `${this.props.config[constants.GuiContainer][constants.GuiTarget]}/${constants.SEARCH_ENDPOINT}`;
        }
    }
    getJSON() {
        if (this.method === 'POST') {
            return JSON.parse(JSON.stringify(new SearchJSONBuilder_1.default(this.searchProps).getJSON()));
        }
        else {
            return undefined;
        }
    }
    getStates() {
        return this.props.states;
    }
    isStreamed() {
        return this.streamed;
    }
    getMethod() {
        return this.method;
    }
}
exports.default = QueryController;
